var map = {
	"./icon--arrow.svg": 903,
	"./icon--chevron.svg": 471,
	"./icon--close.svg": 863,
	"./icon--facebook.svg": 227,
	"./icon--linkedin.svg": 697,
	"./icon--mail.svg": 976,
	"./icon--star-boxed.svg": 729,
	"./icon--star-half.svg": 54,
	"./icon--star.svg": 678,
	"./icon--t.svg": 230,
	"./icon--thumbs-up.svg": 527,
	"./icon--trust-pilot.svg": 199,
	"./icon--twitter.svg": 62,
	"./squiggle--large.svg": 147,
	"./squiggle--small.svg": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 526;